var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"my-0 py-0",attrs:{"items":_vm.locales,"label":_vm.label},on:{"change":function($event){return _vm.switchLocale()}},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$t("language." + item + ".text"))+" ")]}},{key:"item",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$t("language." + item + ".text"))+" ")]}}]),model:{value:(_vm.locale),callback:function ($$v) {_vm.locale=$$v},expression:"locale"}})}
var staticRenderFns = []

export { render, staticRenderFns }